import React , { Suspense, lazy }from 'react';

import {
    Routes,
    Route
} from "react-router-dom";
import { Navigate, useLocation } from 'react-router';

import { Auth } from './components/login/authValidate';
import { SignIn } from './components/login/signIn';
import { NonSecureLayout } from './components/template/layout/nonSecureLayout';
import { SecureLayout } from './components/template/layout/secureLayout';
import { Homepage } from './components/upload/homepage';
import { Documents } from './components/upload/Documents/documents';
import MyDocuments from './components/upload/Documents/listingDocs/myDocuments';
import AllDocuments from './components/upload/Documents/listingDocs/allDocuments';
import { Admin } from './components/upload/admin/admin';
import { Search } from './components/search/search';
import { usePermissions } from './hooks/usePermissions';
import { Redirect } from './components/routing/redirect';
import { NewsFeed } from './components/upload/newsFeed/NewsFeed';
import { Roles } from './components/upload/admin/adminListing/roles';
import { TabPanel, TabView } from 'primereact/tabview';
import { getConfiguredLabel } from './common/commonHelper';
import { adminPage, roleTabName } from './common/labelConstants';
import { Users } from './components/upload/admin/adminListing/users';
import { NetworkUpload } from './components/upload/admin/adminListing/networkUpload';
import { Projects } from './components/Projects/projects';


export function Routing() {
    const location = useLocation();
    const permissions = usePermissions();
    

    return (
      
        <Routes>
            <Route element={<NonSecureLayout />}>
                <Route path="/signin" element={<SignIn />} />
                <Route path="/auth" element={<Auth />} />
            </Route>
            <Route element={<SecureLayout />}>
             {/* <Route path="/" element={<SearchHeader />} /> */}
                <Route path="/search" element={<Search/>} /> 
                <Route path="/upload" element={permissions.Edit ? <Homepage key={location.key} /> : <Redirect path='/documents'/>}/>
                {<Route path="/documents" element={<Documents key={location.key } />} /> }
                <Route path="/admin" element={permissions.FullControl ? <Admin /> : <Redirect path='/signin'/>} />
                <Route path="/newsFeed" element={<NewsFeed />} />
                {/* <Route path="/roles" element={<Roles  />}/>
                <Route path="/users" element={<Users/>}/> */}
                <Route path="/dataSource" element={permissions.FullControl ? <NetworkUpload /> : <Redirect path='/signin'/>}/>
                <Route path="*" element={<Navigate to="/documents" replace />} />
                <Route path="/projects" element={<Projects />} />
            </Route>
        </Routes>
      
    )

}